export default {
  HEARTBEAT: 'HEARTBEAT',
  LOGOUT: 'LOGOUT',
  CONNECTION_ESTABLISHED: 'CONNECTION_ESTABLISHED',
  CONNECTION_LOST: 'CONNECTION_LOST',
  SIGNATURE_CHAIN_CREATED: 'SIGNATURE_CHAIN_CREATED',
  SIGNATURE_CHAIN_UPDATED: 'SIGNATURE_CHAIN_UPDATED',
  SIGNATURE_CHAIN_DELETED: 'SIGNATURE_CHAIN_DELETED',
  SIGNATURE_CHAIN_WITHDRAWN: 'SIGNATURE_CHAIN_WITHDRAWN',
  DEVICE_CREATED: 'DEVICE_CREATED',
  DEVICE_UPDATED: 'DEVICE_UPDATED',
  DEVICE_DELETED: 'DEVICE_DELETED'
}
